<dx-radio-group 
    class="radio-group"
    [layout]="layout"
    [(items)]="radioItems"
    [value]="value"
    (onValueChanged)="onValueChanged($event)"
    displayExpr="aciklama"
    [valueExpr]="valueExpr"
    [readOnly]="readOnly"
    [itemTemplate]="'radio'"
    [ngClass]="[value | radioTemplateClass: radioItems, !isRadioBtnValid ? 'dk-not-valid': ''  ]"
    [tabIndex]="tabIndex"

    >


    <div class="radio" *dxTemplate="let data of 'radio'">
      <div [ngClass]="{'green-item':data?.aciklama == 'Evet','red-item':data?.aciklama == 'Hayır' }">{{data?.aciklama}}</div>
   </div>

  </dx-radio-group>